import { HTML_BR_REPLACEMENT } from './html'

export const SIGNATURE_TAG = 'div'

export const SIGNATURE_ATTRIBUTE = 'id'

export const SIGNATURE_PREFIX = 'signature'

export const SIGNATURE_SEPARATOR = HTML_BR_REPLACEMENT
